import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { TagActionContext } from '../../common/types/TagActionContext';

export const templateTagPanel = document.createElement('template');

templateTagPanel.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>
      <div class='form-wrapper'>
        <gz-tag-details-form context='${TagActionContext.Create}'></gz-tag-details-form>
      </div>

      <div class='bottom-buttons'>
        <gz-button id='save-button' disabled></gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
`;
